export const refinanceFormRoutes: Record<string, any> = {
  purchase_detail: '/mortgage/refinance/step/purchase-detail',
  personal_detail: '/mortgage/refinance/step/personal-detail',
  property_detail: '/mortgage/refinance/step/property-detail',
  income_detail: '/mortgage/refinance/step/income-detail',
  primary_detail: '/mortgage/refinance/step/primary-detail',
};
